export default [
  {
    title: 'Имя (А-Я)',
    field: 'fio.asc',
    options: {
      by: 'fio',
      order: 'asc'
    }
  },
  {
    title: 'Имя (Я-А)',
    field: 'fio.desc',
    options: {
      by: 'fio',
      order: 'desc'
    }
  },
  {
    title: 'Дата по возрастанию',
    field: 'created_at.asc',
    options: {
      by: 'created_at',
      order: 'asc'
    }
  },
  {
    title: 'Дата по убыванию',
    field: 'created_at.desc',
    options: {
      by: 'created_at',
      order: 'desc'
    }
  },
  // {
  //   title: 'По возрастанию',
  //   field: 'id.asc',
  //   options: {
  //     by: 'id',
  //     order: 'asc'
  //   }
  // },
  // {
  //   title: 'По убыванию',
  //   field: 'id.desc',
  //   options: {
  //     by: 'id',
  //     order: 'desc'
  //   }
  // },
]